import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { t } from "i18next";
import PropTypes from "prop-types";
import { useState } from "react";
export const AccordionComponent = ({
  header1,
  des1,
  header2,
  des2,
  header3,
  des3,
  header4,
  des4,
  header5,
  des5,
  check,
  check3,
  check4,
}) => {
  const [expanded, setExpanded] = useState(null);
  let checkTop = false;
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
    setShowBorder(true);
    checkTop = true;
  };
  const [showBorder, setShowBorder] = useState(false);
  setTimeout(() => {
    setShowBorder(false);
  }, 500);
  return (
    <div className="max-w-[640px] lg:max-w-[850px] lgmax:max-w-[850px] ">
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleAccordionChange("panel1")}
        sx={{
          margin: "0px !important",
          border:
            showBorder && expanded === "panel1"
              ? "1px solid #565ADD"
              : "1px solid rgba(2, 1, 1, 0.15)",
          borderLeft:
            expanded === "panel1"
              ? "5px solid #565ADD"
              : "1px solid rgba(2, 1, 1, 0.15)",
          borderTop:
            showBorder && expanded === "panel1"
              ? "1px solid #565ADD"
              : expanded === "panel1"
                ? "none"
                : "1px solid rgba(2, 1, 1, 0.15)",
          borderRight: "none",
          boxShadow: "none",
          borderRadius: "0px !important",
          borderBottom: expanded === "panel1" ? "none" : "",
        }}
      >
        <AccordionSummary
          expandIcon={
            expanded === "panel1" ? (
              <RemoveIcon sx={{ color: "#565ADD" }} />
            ) : (
              <AddIcon sx={{ color: "#2B1C50" }} />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ margin: "0px", paddingLeft: "26px" }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              color: expanded === "panel1" ? "#565ADD" : "#2B1C50",
              fontWeight: "700",
            }}
          >
            {header1}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            paddingLeft: "26px",
            borderTop: "1px solid rgba(2, 1, 1, 0.15)",
          }}
        >
          <Typography
            sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
          >
            {des1}
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleAccordionChange("panel2")}
        sx={{
          margin: "0px !important",
          border:
            showBorder && expanded === "panel2"
              ? "1px solid #565ADD"
              : "1px solid rgba(2, 1, 1, 0.15)",
          borderLeft: expanded === "panel2" ? "5px solid #565ADD" : "",
          borderTop:
            showBorder && expanded === "panel2"
              ? "1px solid #565ADD"
              : "1px solid rgba(2, 1, 1, 0.15)",
          borderRight: "none",
          boxShadow: "none",
          borderRadius: "0px !important",
          borderBottom: expanded === "panel2" ? "none" : "",
        }}
      >
        <AccordionSummary
          expandIcon={
            expanded === "panel2" ? (
              <RemoveIcon sx={{ color: "#565ADD" }} />
            ) : (
              <AddIcon sx={{ color: "#2B1C50" }} />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ margin: "0px", paddingLeft: "26px" }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              color: expanded === "panel2" ? "#565ADD" : "#2B1C50",
              fontWeight: "700",
            }}
          >
            {header2}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            paddingLeft: "26px",
            borderTop: "1px solid rgba(2, 1, 1, 0.15)",
          }}
        >
          <Typography
            sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
          >
            {des2}
          </Typography>
        </AccordionDetails>
      </Accordion>
      {check3 === true ? (
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleAccordionChange("panel3")}
          sx={{
            margin: "0px !important",
            border:
              showBorder && expanded === "panel3"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderLeft: expanded === "panel3" ? "5px solid #565ADD" : "",
            borderTop:
              showBorder && expanded === "panel3"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderRight: "none",
            boxShadow: "none",
            borderRadius: "0px !important",
            borderBottom: expanded === "panel3" ? "none" : "",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel3" ? (
                <RemoveIcon sx={{ color: "#565ADD" }} />
              ) : (
                <AddIcon sx={{ color: "#2B1C50" }} />
              )
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ margin: "0px", paddingLeft: "26px" }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                color: expanded === "panel3" ? "#565ADD" : "#2B1C50",
                fontWeight: "700",
              }}
            >
              {header3}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              paddingLeft: "26px",
              borderTop: "1px solid rgba(2, 1, 1, 0.15)",
            }}
          >
            <Typography
              sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
            >
              <ul className=" list-disc ">
                {des3}
                <li className="mt-[15px]">{t("upiqrcode.howdochild1")}</li>
                <li>{t("upiqrcode.howdochild2")}</li>
                <li>{t("upiqrcode.howdochild3")}</li>
                <li>{t("upiqrcode.howdochild4")}</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ) : (
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleAccordionChange("panel3")}
          sx={{
            margin: "0px !important",
            border:
              showBorder && expanded === "panel3"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderLeft: expanded === "panel3" ? "5px solid #565ADD" : "",
            borderTop:
              showBorder && expanded === "panel3"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderRight: "none",
            boxShadow: "none",
            borderRadius: "0px !important",
            borderBottom: expanded === "panel3" ? "none" : "",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel3" ? (
                <RemoveIcon sx={{ color: "#565ADD" }} />
              ) : (
                <AddIcon sx={{ color: "#2B1C50" }} />
              )
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ margin: "0px", paddingLeft: "26px" }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                color: expanded === "panel3" ? "#565ADD" : "#2B1C50",
                fontWeight: "700",
              }}
            >
              {header3}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              paddingLeft: "26px",
              borderTop: "1px solid rgba(2, 1, 1, 0.15)",
            }}
          >
            <Typography
              sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
            >
              {des3}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
      {check4 === true ? (
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleAccordionChange("panel4")}
          sx={{
            margin: "0px !important",
            border:
              showBorder && expanded === "panel4"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderLeft: expanded === "panel4" ? "5px solid #565ADD" : "",
            borderTop:
              showBorder && expanded === "panel4"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderRight: "none",
            boxShadow: "none",
            borderRadius: "0px !important",
            borderBottom: expanded === "panel4" ? "none" : "",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel4" ? (
                <RemoveIcon sx={{ color: "#565ADD" }} />
              ) : (
                <AddIcon sx={{ color: "#2B1C50" }} />
              )
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ margin: "0px", paddingLeft: "26px" }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                color: expanded === "panel4" ? "#565ADD" : "#2B1C50",
                fontWeight: "700",
              }}
            >
              {header4}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              paddingLeft: "26px",
              borderTop: "1px solid rgba(2, 1, 1, 0.15)",
            }}
          >
            <Typography
              sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
            >
              <ul className=" list-disc ">
                {des4}
                <li className="mt-[15px]">{t("enach.whataredeschilder")}</li>
                <li>{t("enach.whataredeschilder1")}</li>
                <li>{t("enach.whataredeschilder2")}</li>
                <li>{t("enach.whataredeschilder3")}</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ) : (
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleAccordionChange("panel4")}
          sx={{
            margin: "0px !important",
            border:
              showBorder && expanded === "panel4"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderLeft: expanded === "panel4" ? "5px solid #565ADD" : "",
            borderTop:
              showBorder && expanded === "panel4"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderRight: "none",
            boxShadow: "none",
            borderRadius: "0px !important",
            borderBottom: expanded === "panel4" ? "none" : "",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel4" ? (
                <RemoveIcon sx={{ color: "#565ADD" }} />
              ) : (
                <AddIcon sx={{ color: "#2B1C50" }} />
              )
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ margin: "0px", paddingLeft: "26px" }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                color: expanded === "panel4" ? "#565ADD" : "#2B1C50",
                fontWeight: "700",
              }}
            >
              {header4}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              paddingLeft: "26px",
              borderTop: "1px solid rgba(2, 1, 1, 0.15)",
            }}
          >
            <Typography
              sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
            >
              {des4}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}

      {check === true ? (
        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleAccordionChange("panel5")}
          sx={{
            margin: "0px !important",
            border:
              showBorder && expanded === "panel5"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderLeft: expanded === "panel5" ? "5px solid #565ADD" : "",
            borderTop:
              showBorder && expanded === "panel5"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderRight: "none",
            boxShadow: "none",
            borderRadius: "0px !important",
            borderBottom: expanded === "panel5" ? "none" : "",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel5" ? (
                <RemoveIcon sx={{ color: "#565ADD" }} />
              ) : (
                <AddIcon sx={{ color: "#2B1C50" }} />
              )
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ margin: "0px", paddingLeft: "26px" }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                color: expanded === "panel5" ? "#565ADD" : "#2B1C50",
                fontWeight: "700",
              }}
            >
              {header5}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              paddingLeft: "26px",
              borderTop: "1px solid rgba(2, 1, 1, 0.15)",
            }}
          >
            <Typography
              sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
            >
              <ul className=" list-disc ">
                {des5}
                <li className="mt-[15px]">{t("apibanking.howwilldes1")}</li>
                <li>{t("apibanking.howwilldes2")}</li>
                <li>{t("apibanking.howwilldes3")}</li>
                <li>{t("apibanking.howwilldes4")}</li>
                <li>{t("apibanking.howwilldes5")}</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ) : (
        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleAccordionChange("panel5")}
          sx={{
            margin: "0px !important",
            border:
              showBorder && expanded === "panel5"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderLeft: expanded === "panel5" ? "5px solid #565ADD" : "",
            borderTop:
              showBorder && expanded === "panel5"
                ? "1px solid #565ADD"
                : "1px solid rgba(2, 1, 1, 0.15)",
            borderRight: "none",
            boxShadow: "none",
            borderRadius: "0px !important",
            borderBottom: expanded === "panel5" ? "none" : "",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel5" ? (
                <RemoveIcon sx={{ color: "#565ADD" }} />
              ) : (
                <AddIcon sx={{ color: "#2B1C50" }} />
              )
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ margin: "0px", paddingLeft: "26px" }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                color: expanded === "panel5" ? "#565ADD" : "#2B1C50",
                fontWeight: "700",
              }}
            >
              {header5}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              paddingLeft: "26px",
              borderTop: "1px solid rgba(2, 1, 1, 0.15)",
            }}
          >
            <Typography
              sx={{ fontSize: "16px", color: "#3D2E7C", fontWeight: "400" }}
            >
              {des5}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
};
AccordionComponent.propTypes = {
  header1: PropTypes.string,
  des1: PropTypes.string,
  header2: PropTypes.string,
  des2: PropTypes.string,
  header3: PropTypes.string,
  des3: PropTypes.string,
  header4: PropTypes.string,
  des4: PropTypes.string,
  header5: PropTypes.string,
  des5: PropTypes.string,
  check: PropTypes.bool,
  check3: PropTypes.bool,
  check4: PropTypes.bool,
};
